import styled, { css } from 'styled-components';

const ContainerWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  width: 100%;

  ${(props) =>
    props.fullWidth &&
    css`
      width: 100%;
      max-width: none !important;
    `};

  ${(props) =>
    (props.noGutter &&
      css`
        padding-left: 0;
        padding-right: 0;
      `) ||
    css`
      padding-left: 24px;
      padding-right: 24px;

      @media (max-width: 1200px) {
        padding-left: 20px;
        padding-right: 20px;
      }

      @media (max-width: 768px) {
        padding-left: 16px;
        padding-right: 16px;
      }

      @media (max-width: 380px) {
        padding-left: 12px;
        padding-right: 12px;
      }
    `};

  @media (min-width: 768px) {
    max-width: 750px;
  }
  @media (min-width: 992px) {
    max-width: 970px;
  }
  @media (min-width: 1220px) {
    max-width: ${(props) => props.width || '1240px'};
  }
  @media (min-width: 1440px) {
    max-width: ${(props) => props.width || '1280px'};
  }
`;

export default ContainerWrapper;
